import { Directive, ElementRef, OnDestroy, afterNextRender, inject } from '@angular/core';

/**
 * Moves focus into a Sheets dialog when it opens, and back where it was when it closes.
 *
 * The dialogs were opened from a menu item that is gone by the time they render, so focus fell to
 * `<body>`: their Escape handlers (bound on the dialog) never fired, and a keyboard user started
 * outside the dialog they had just opened (NFR-7).
 */
@Directive({
  selector: '[appDialogFocus]',
  standalone: true,
  host: { tabindex: '-1', 'aria-modal': 'true', '[style.outline]': "'none'" },
})
export class DialogFocusDirective implements OnDestroy {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly before = document.activeElement as HTMLElement | null;

  public constructor() {
    afterNextRender(() => {
      if (!this.host.nativeElement.contains(document.activeElement)) this.host.nativeElement.focus();
    });
  }

  public ngOnDestroy(): void {
    const before = this.before;
    if (before && before !== document.body && before.isConnected) before.focus();
  }
}
